/*********************************************/
/*               元素属性参数类型               */
/*********************************************/
/**
 * 渲染等级
 */
export var RenderLevel;
(function (RenderLevel) {
    RenderLevel["S"] = "S";
    RenderLevel["APlus"] = "A+";
    RenderLevel["A"] = "A";
    RenderLevel["BPlus"] = "B+";
    RenderLevel["B"] = "B";
})(RenderLevel || (RenderLevel = {}));
/**
 * 混合模式
 */
export var BlendingMode;
(function (BlendingMode) {
    /**
     * 普通混合模式
     */
    BlendingMode[BlendingMode["ALPHA"] = 0] = "ALPHA";
    /**
     * 叠加混合模式
     */
    BlendingMode[BlendingMode["ADD"] = 1] = "ADD";
    /**
     * 相乘混合模式
     */
    BlendingMode[BlendingMode["MULTIPLY"] = 2] = "MULTIPLY";
    /**
     * 亮度混合模式
     */
    BlendingMode[BlendingMode["BRIGHTNESS"] = 3] = "BRIGHTNESS";
    /**
     * 减色混合模式
     */
    BlendingMode[BlendingMode["SUBTRACTION"] = 4] = "SUBTRACTION";
    /**
     * 强光混合模式
     */
    BlendingMode[BlendingMode["STRONG_LIGHT"] = 5] = "STRONG_LIGHT";
    /**
     * 弱光混合模式
     */
    BlendingMode[BlendingMode["WEAK_LIGHT"] = 6] = "WEAK_LIGHT";
    /**
     * 亮度叠加混合模式
     */
    BlendingMode[BlendingMode["SUPERPOSITION"] = 7] = "SUPERPOSITION";
})(BlendingMode || (BlendingMode = {}));
/**
 * 单双面模式
 */
export var SideMode;
(function (SideMode) {
    /**
     * 双面模式
     */
    SideMode[SideMode["DOUBLE"] = 1032] = "DOUBLE";
    /**
     * 正面模式
     */
    SideMode[SideMode["FRONT"] = 1028] = "FRONT";
    /**
     * 背面模式
     */
    SideMode[SideMode["BACK"] = 1029] = "BACK";
})(SideMode || (SideMode = {}));
/**
 *  元素是否被蒙版遮挡/反向遮挡
 */
export var ObscuredMode;
(function (ObscuredMode) {
    /**
     * 无
     */
    // NONE = 0,
    // /**
    //  * 蒙版
    //  */
    // MASK = 1,
    /**
     * 被遮挡
     */
    ObscuredMode[ObscuredMode["OBSCURED"] = 2] = "OBSCURED";
    /**
     * 被反向遮挡
     */
    ObscuredMode[ObscuredMode["REVERSE_OBSCURED"] = 3] = "REVERSE_OBSCURED";
})(ObscuredMode || (ObscuredMode = {}));
/**
 * 发射器形状
 */
export var ParticleEmitterShapeType;
(function (ParticleEmitterShapeType) {
    /**
     * 没有类型
     */
    ParticleEmitterShapeType[ParticleEmitterShapeType["NONE"] = 0] = "NONE";
    /**
     * 圆球
     */
    ParticleEmitterShapeType[ParticleEmitterShapeType["SPHERE"] = 1] = "SPHERE";
    /**
     * 圆锥
     */
    ParticleEmitterShapeType[ParticleEmitterShapeType["CONE"] = 2] = "CONE";
    /**
     * 半球
     */
    ParticleEmitterShapeType[ParticleEmitterShapeType["HEMISPHERE"] = 3] = "HEMISPHERE";
    /**
     * 圆
     */
    ParticleEmitterShapeType[ParticleEmitterShapeType["CIRCLE"] = 4] = "CIRCLE";
    /**
     * 圆环
     */
    ParticleEmitterShapeType[ParticleEmitterShapeType["DONUT"] = 5] = "DONUT";
    /**
     * 矩形
     */
    ParticleEmitterShapeType[ParticleEmitterShapeType["RECTANGLE"] = 6] = "RECTANGLE";
    /**
     * 矩形框
     */
    ParticleEmitterShapeType[ParticleEmitterShapeType["RECTANGLE_EDGE"] = 7] = "RECTANGLE_EDGE";
    /**
     * 直线
     */
    ParticleEmitterShapeType[ParticleEmitterShapeType["EDGE"] = 8] = "EDGE";
    /**
     * 贴图
     */
    ParticleEmitterShapeType[ParticleEmitterShapeType["TEXTURE"] = 9] = "TEXTURE";
})(ParticleEmitterShapeType || (ParticleEmitterShapeType = {}));
/**
 * 插件类型
 */
export var PluginType;
(function (PluginType) {
    /**
     * 陀螺仪
     */
    PluginType[PluginType["GYROSCOPE"] = 0] = "GYROSCOPE";
    /**
     * Spine
     */
    PluginType[PluginType["SPINE"] = 1] = "SPINE";
})(PluginType || (PluginType = {}));
/**
 * 交互类型
 */
export var InteractType;
(function (InteractType) {
    /**
     * 点击
     */
    InteractType[InteractType["CLICK"] = 0] = "CLICK";
    /**
     * 消息
     * 前端收到 onMessageItem 回调
     */
    InteractType[InteractType["MESSAGE"] = 1] = "MESSAGE";
    /**
     * 拖拽
     */
    InteractType[InteractType["DRAG"] = 2] = "DRAG";
})(InteractType || (InteractType = {}));
/**
 * 交互行为
 */
export var InteractBehavior;
(function (InteractBehavior) {
    /**
     * 无
     */
    InteractBehavior[InteractBehavior["NONE"] = 0] = "NONE";
    /**
     * 通知
     */
    InteractBehavior[InteractBehavior["NOTIFY"] = 1] = "NOTIFY";
    /**
     * 重置播放器
     */
    InteractBehavior[InteractBehavior["RESUME_PLAYER"] = 2] = "RESUME_PLAYER";
    /**
     * 清除元素
     */
    InteractBehavior[InteractBehavior["REMOVE"] = 3] = "REMOVE";
    /**
     * 暂停播放器
     */
    InteractBehavior[InteractBehavior["PAUSE"] = 4] = "PAUSE";
})(InteractBehavior || (InteractBehavior = {}));
/**
 * 元素类型
 */
export var ItemType;
(function (ItemType) {
    /**
     * 错误元素
     */
    ItemType["base"] = "0";
    /**
     * 图层元素
     */
    ItemType["sprite"] = "1";
    /**
     * 粒子元素
     */
    ItemType["particle"] = "2";
    /**
     * 空节点元素
     */
    ItemType["null"] = "3";
    /**
     * 交互元素
     */
    ItemType["interact"] = "4";
    /**
     * 插件元素
     */
    ItemType["plugin"] = "5";
    /**
     * 相机元素
     */
    ItemType["camera"] = "6";
    /**
     * 预合成元素
     */
    ItemType["composition"] = "7";
    /**
     * Spine 元素
     */
    ItemType["spine"] = "spine";
    /**
     * Mesh 元素
     */
    ItemType["mesh"] = "mesh";
    /**
     * 节点树元素
     */
    ItemType["tree"] = "tree";
    /**
     * 文本元素
     */
    ItemType["text"] = "text";
    /**
     * 灯光元素
     */
    ItemType["light"] = "light";
    /**
     * 天空盒元素
     */
    ItemType["skybox"] = "skybox";
    /**
     * 特效元素
     */
    ItemType["effect"] = "effect";
    /**
     * 形状元素
     */
    ItemType["shape"] = "shape";
    /**
     * 后处理元素
     */
    ItemType["postProcessVolume"] = "postProcessVolume";
    /**
     * 节点元素
     */
    ItemType["node"] = "node";
    /**
     * 视频元素
     */
    ItemType["video"] = "video";
    /**
     * 音频元素
     */
    ItemType["audio"] = "audio";
    /**
     * 富文本元素
     */
    ItemType["richtext"] = "richtext";
})(ItemType || (ItemType = {}));
/**
 * 渲染模式
 */
export var RenderMode;
(function (RenderMode) {
    /**
     * 广告牌模式
     */
    RenderMode[RenderMode["BILLBOARD"] = 0] = "BILLBOARD";
    /**
     * 网格模式
     */
    RenderMode[RenderMode["MESH"] = 1] = "MESH";
    /**
     * 垂直广告牌模式
     */
    RenderMode[RenderMode["VERTICAL_BILLBOARD"] = 2] = "VERTICAL_BILLBOARD";
    /**
     * 水平广告牌模式
     */
    RenderMode[RenderMode["HORIZONTAL_BILLBOARD"] = 3] = "HORIZONTAL_BILLBOARD";
})(RenderMode || (RenderMode = {}));
/**
 * 变换中心
 */
export var ParticleOrigin;
(function (ParticleOrigin) {
    /**
     * 水平和垂直中点
     */
    ParticleOrigin[ParticleOrigin["PARTICLE_ORIGIN_CENTER"] = 0] = "PARTICLE_ORIGIN_CENTER";
    /**
     * 水平左侧 垂直顶部
     */
    ParticleOrigin[ParticleOrigin["PARTICLE_ORIGIN_LEFT_TOP"] = 1] = "PARTICLE_ORIGIN_LEFT_TOP";
    /**
     * 水平左侧 垂直中间
     */
    ParticleOrigin[ParticleOrigin["PARTICLE_ORIGIN_LEFT_CENTER"] = 2] = "PARTICLE_ORIGIN_LEFT_CENTER";
    /**
     * 水平左侧 垂直底部
     */
    ParticleOrigin[ParticleOrigin["PARTICLE_ORIGIN_LEFT_BOTTOM"] = 3] = "PARTICLE_ORIGIN_LEFT_BOTTOM";
    /**
     * 水平中间 垂直顶部
     */
    ParticleOrigin[ParticleOrigin["PARTICLE_ORIGIN_CENTER_TOP"] = 4] = "PARTICLE_ORIGIN_CENTER_TOP";
    /**
     * 水平中间 垂直底部
     */
    ParticleOrigin[ParticleOrigin["PARTICLE_ORIGIN_CENTER_BOTTOM"] = 5] = "PARTICLE_ORIGIN_CENTER_BOTTOM";
    /**
     * 水平右侧 垂直顶部
     */
    ParticleOrigin[ParticleOrigin["PARTICLE_ORIGIN_RIGHT_TOP"] = 6] = "PARTICLE_ORIGIN_RIGHT_TOP";
    /**
     * 水平右侧 垂直中间
     */
    ParticleOrigin[ParticleOrigin["PARTICLE_ORIGIN_RIGHT_CENTER"] = 7] = "PARTICLE_ORIGIN_RIGHT_CENTER";
    /**
     * 水平右侧 垂直底部
     */
    ParticleOrigin[ParticleOrigin["PARTICLE_ORIGIN_RIGHT_BOTTOM"] = 8] = "PARTICLE_ORIGIN_RIGHT_BOTTOM";
})(ParticleOrigin || (ParticleOrigin = {}));
export var RenderType;
(function (RenderType) {
    RenderType["Opaque"] = "Opaque";
    RenderType["Transparent"] = "Transparent";
})(RenderType || (RenderType = {}));
export var RenderFace;
(function (RenderFace) {
    RenderFace["Both"] = "Both";
    RenderFace["Back"] = "Back";
    RenderFace["Front"] = "Front";
})(RenderFace || (RenderFace = {}));
